/**
 * The one-time all-access pass, read from the public plan catalogue.
 *
 * Price and duration are whatever an admin configured on the plan row — never
 * hardcoded — so a change in the admin panel moves every CTA at once.
 */
import { useQuery } from "@tanstack/react-query";
import { publicSubscriptionPlansQuery } from "@/lib/subscriptionPlansQuery";
import type { PublicSubscriptionPlan } from "@/lib/subscriptionPlans.functions";
import { INTRO_OFFERS_ENABLED } from "@/lib/introPassPath";

export { INTRO_PASS_CHECKOUT_PATH } from "@/lib/introPassPath";

export function useIntroPassPlan(): {
  pass: PublicSubscriptionPlan | null;
  loading: boolean;
} {
  const { data, isLoading } = useQuery(publicSubscriptionPlansQuery);
  const pass = !INTRO_OFFERS_ENABLED ? null : (data ?? []).find((p) => p.is_intro_pass === true) ?? null;
  return { pass, loading: isLoading };
}

/** Price an all-access pass buyer actually pays, in INR. */
export function introPassPriceINR(pass: PublicSubscriptionPlan | null): number | null {
  if (!pass) return null;
  const amount = Number(pass.discounted_price ?? pass.price ?? 0);
  return Number.isFinite(amount) && amount > 0 ? amount : null;
}
